import { z } from "zod"
import { TranslationKey } from "../../i18n/translation-key"

export const InspectionOrderPartSchema = z.object({
  partId: z.string().uuid(),
  isHidden: z.boolean(),
})

export const InspectionOrderPartWithNameSchema =
  InspectionOrderPartSchema.extend({
    name: z.string(),
  })

export const InspectionOrderSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  /** Every active part for the store, in display order */
  parts: z.array(InspectionOrderPartWithNameSchema),
})

export const CreateInspectionOrderSchema = z.object({
  name: z
    .string()
    .trim()
    .min(1, "common.validation.enterName" satisfies TranslationKey),
})

export const UpdateInspectionOrderSchema = z.object({
  name: z
    .string()
    .trim()
    .min(1, "common.validation.enterName" satisfies TranslationKey),
  /** In display order, the index becomes the part's sort order */
  parts: z.array(InspectionOrderPartSchema),
})

export type InspectionOrderPart = z.infer<typeof InspectionOrderPartSchema>
export type InspectionOrderPartWithName = z.infer<
  typeof InspectionOrderPartWithNameSchema
>
export type InspectionOrder = z.infer<typeof InspectionOrderSchema>
export type CreateInspectionOrder = z.infer<typeof CreateInspectionOrderSchema>
export type UpdateInspectionOrder = z.infer<typeof UpdateInspectionOrderSchema>
